module.exports = __webpack_public_path__ + "components/flag/static/square/bj-603c54ab690279e1b2b3f9ab2e23a1a6.svg";